import React from 'react';

interface NextDropDateSeparatorProps {

}

export const NextDropDateSeparator: React.FC<NextDropDateSeparatorProps> = () => {
  return (
    <div className="free-drop-live-data-points">:</div>
  );
};
